import React, {Component} from 'react'
import {Media, Image, Button, Popover, OverlayTrigger, Tooltip} from 'react-bootstrap'
import PointComponent from './PointComponent'
import SocialShareComponent from '../Common/SocialShare/SocialShareComponent'
import {Form} from 'react-form'
import validatePoint from '../../utils/validatePoint'
import {Actions} from 'jumpstate'
import showToastr from '../../utils/showToastr'
import ErrorHandler from '../../utils/ErrorHandler'
import {FaMagnet, FaClipboard, MdShare} from '../Common/ReactIcons/icons'
import Clipboard from 'clipboard'

import './Layout/Feature.css'

const avatar = `${window.location.protocol}//${window.location.host}/default_avatar.png`

class FeatureComponent extends Component {
  constructor (props) {
    super(props)

    this.state = {
      message: {type: '', context: ''},
      feature: props.feature,
      form: {
        id: this.props.feature.id,
        point: ''
      },
      link: `${window.location.origin}/new-feature/${this.props.feature.id}`,
      supportsClipboard: window.__BROWSER_ENV__,
      clipboard: window.__BROWSER_ENV__ ? new Clipboard('.copy-button') : {},
      isLoading: false
    }
    this.addPoint = this.addPoint.bind(this)
    this.prepareClipboard()
    this.checkAuthentication = this.checkAuthentication.bind(this)
  }

  checkAuthentication (e) {
    if (!this.props.isAuthenticated) {
      showToastr('warning', 'ویژگی جدید', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }
  }

  prepareClipboard () {
    if (!this.state.supportsClipboard) { return undefined }
    this.state.clipboard.on('success', (e) => {
      const matches = /\/([0-9]+)$/.exec(e.text)
      if (parseInt(matches[1], 10) === this.props.feature.id) {
        showToastr('info', 'ویژگی جدید', `لینک ویژگی "${this.props.feature.title}" به حافظه منتقل شد`)
      }
    })
  }

  addPoint (values) {
    if (!this.props.isAuthenticated) {
      document.getElementById(`pointOverlay${values.id}`).click()
      showToastr('warning', 'ویژگی جدید', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }
    this.setState({isLoading: true})
    Actions.addPointToFeature(values).then((res) => {
      this.setState({isLoading: false})
      res.updatedFeature.then((res) => this.setState({feature: res.data}))
      document.getElementById(`pointOverlay${values.id}`).click()
      showToastr('success', 'ویژگی جدید', res.data.messages[0])
    }).catch((err) => {
      let eh = new ErrorHandler(err)
      this.setState({message: eh.message, isLoading: false})
      eh.setFormErrors(this.refs.point)
      eh.showToastrIn('ویژگی جدید')
    })
  }

  render () {
    const {user, isAuthenticated} = this.props
    const {form, link, feature, isLoading, supportsClipboard, message} = this.state

    const addPointPopover = (
      <Popover id={`popoverToFeature${feature.id}`} title="به این ویژگی نعل بدهید.">
        {message.context && <div className="alert alert-danger">{message.context}</div>}
        <Form
          ref="point"
          validate={validatePoint}
          values={form}
          onSubmit={this.addPoint}
          user={user}
          disable={isLoading}
          isLoading={isLoading}
        >
          {PointComponent}
        </Form>
      </Popover>
    )

    const sharePopover = (
      <Popover id={`popoverShareFeature${feature.id}`} title="با دوستانتان به اشتراک بگذارید.">
        <SocialShareComponent
          url={link}
          title={feature.title}
          description={feature.description} />
      </Popover>
    )

    return (
      <Media className={feature.maxPoint <= feature.point ? 'done' : ''}>
        <Media.Left>
          <div className="point-icon"><FaMagnet /></div>
          <span className="point">{feature.point}</span>
          <span className="max-point">/ {feature.maxPoint}</span>

          {isAuthenticated && <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={addPointPopover}>
            <Button id={`pointOverlay${feature.id}`} bsStyle="info" className="add-point">نعل بدهید</Button>
          </OverlayTrigger>}
          {!isAuthenticated && <Button onClick={this.checkAuthentication} bsStyle="info" className="add-point">نعل بدهید</Button>}
        </Media.Left>

        <Media.Body>
          <Media.Heading>{feature.title}</Media.Heading>

          {supportsClipboard && Clipboard.isSupported() && <div className="copy-button" data-clipboard-text={link}><FaClipboard /></div>}

          <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={sharePopover}>
            <div className="share-button"><MdShare /></div>
          </OverlayTrigger>

          <div className="owner"><Image src={feature.owner.avatar ? feature.owner.avatar : avatar} alt={feature.owner.name} /> {feature.owner.name}</div>

          <div className="description">{feature.description}</div>

          {feature.userPoints.length !== 0 && <div className="user-points">
            <div className="progress-bar" style={{width: `${feature.point / feature.maxPoint * 100}%`}} />
            {feature.userPoints.map((user, index) => (
              <OverlayTrigger key={index} placement="top" overlay={<Tooltip id={`tooltip${feature.id}`}>{user.name}</Tooltip>}>
                <Image key={index} src={user.avatar ? user.avatar : avatar} alt={user.name} />
              </OverlayTrigger>
            ))}
          </div>}

        </Media.Body>
      </Media>
    )
  }
}

FeatureComponent.propTypes = {
  feature: React.PropTypes.object.isRequired,
  user: React.PropTypes.object,
  isAuthenticated: React.PropTypes.bool.isRequired
}

export default FeatureComponent



// WEBPACK FOOTER //
// ./src/components/Feature/FeatureComponent.js